// TODO: Move ALL_ZONES_ID and NO_RESIDENT_SELECTED_ID here
export const ALL_ASSIGNMENTS_ID = -1; // Not dangerous because we're not sending this to the backend
